import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getUsers } from '../actions/UserActions';
import DataTable from '../../common/DataTable/DataTable';
import { Link } from 'react-router-dom';
import { Button, Pane } from 'evergreen-ui';

class ListUsers extends Component {
    componentDidMount() {
        
    }

    handleTableChange = (opts) => {
        this.props.dispatch(getUsers(opts));
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/users/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Utilizator nou
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    {id: 'id', label: 'Id'},
                    {id: 'name', label: 'Nume',},
                    {id: 'email', label: 'Email'},
                    {id: 'roleId', label: 'Rol', decorator: (user => user.roleName)},
                    {id: 'createdAt', label: 'Creat', decorator: 'date'},
                    {id: 'updatedAt', label: 'Updated', decorator: 'date'}
                ]}

                data={this.props.data}

                onTableChange={this.handleTableChange}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}

                itemMenu={[
                    { getLink: (item) => `/users/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/users/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.users;
}

export default connect(mapStateToProps)(ListUsers);